export interface FileErrors {
  invalidType: string;
  sizeLimit: string;
}

export function validateFile(
  file: File,
  maxDocumentSize: number,
  accept: string,
  fileErrors: FileErrors,
) {
  if (!accept.includes(file.type)) {
    return {
      isValid: false,
      errorMessage: fileErrors.invalidType,
    };
  }
  if (file.size > maxDocumentSize || file.size <= 0) {
    return {
      isValid: false,
      errorMessage: fileErrors.sizeLimit,
    };
  }
  return { isValid: true };
}
